//  ContextMenu - creates a menu near the given anchor element
import React from 'react'
import PropTypes from 'prop-types'
import { Menu, MenuItem } from '@material-ui/core'

const propForItem = (prop, item) => (typeof prop === 'function' ? prop(item) : prop)

class ContextMenu extends React.Component {
	render() {
		const { contextMenuItems, anchorEl, item, handleContextClose, menuItemClickBinder } = this.props

		if (item && anchorEl && contextMenuItems) {
			return (
				<Menu
					anchorEl={anchorEl}
					onClose={handleContextClose}
					open
				>
					{propForItem(contextMenuItems, item).map(menuItem => (
						<MenuItem key={menuItem.name} onClick={menuItemClickBinder(menuItem.handler)}>
							{menuItem.name}
						</MenuItem>
					))}
				</Menu>
			)
		}
		return null
	}
}


ContextMenu.propTypes = {
	contextMenuItems: PropTypes.oneOfType([PropTypes.func, PropTypes.array]),
	anchorEl: PropTypes.oneOfType([PropTypes.element, PropTypes.object]), // eslint-disable-line react/forbid-prop-types
	item: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]), // eslint-disable-line react/forbid-prop-types
	handleContextClose: PropTypes.func,
	menuItemClickBinder: PropTypes.func
}

ContextMenu.defaultProps = {
	item: undefined,
	anchorEl: undefined,
	contextMenuItems: undefined,
	handleContextClose: () => {},
	menuItemClickBinder: () => {}
}

export default ContextMenu



// WEBPACK FOOTER //
// ./src/components/ContextMenu.jsx